import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

const getThankyouReturnUrl = () => {
  if (process.env.REACT_APP_FRONTEND_URL) {
    const base = process.env.REACT_APP_FRONTEND_URL.startsWith("http")
      ? process.env.REACT_APP_FRONTEND_URL
      : `https://${process.env.REACT_APP_FRONTEND_URL}`;
    return `${base}/thankyou`;
  }
  return `${window.location.origin}/thankyou`;
};

const CheckoutForm = ({ dpmCheckerLink, orderData, amount }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    sessionStorage.setItem("pendingOrderData", JSON.stringify(orderData[0]));

    const returnUrl = getThankyouReturnUrl();

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(
          error.message ||
            "Payment failed. Please check your card details and try again.",
        );
      } else if (error.type === "invalid_request_error") {
        setMessage(
          error.message ||
            "Invalid payment request. Please try again or contact support.",
        );
      } else {
        setMessage(
          error.message || "An unexpected error occurred. Please try again.",
        );
      }
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
    paymentMethodOrder: ["card"],
    // Shared in-store kiosk device: never show Link (which offers to save/
    // autofill a customer's info for reuse) or the Apple Pay/Google Pay
    // inline wallet buttons, which pull from whatever is saved on the
    // device itself rather than anything scoped to the individual customer.
    wallets: {
      applePay: "never",
      googlePay: "never",
      link: "never",
    },
  };

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <button
          className="buttonpayment"
          disabled={isLoading || !stripe || !elements}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? "Processing Please wait..." : "Pay now"}
          </span>
        </button>
        {message && <div id="payment-message">{message}</div>}
      </form>
    </>
  );
};

export default CheckoutForm;
